import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-brand-navy relative overflow-hidden" data-id="element-146">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-emerald/20 rounded-full blur-[120px] pointer-events-none" data-id="element-147"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl overflow-hidden shadow-2xl" data-id="element-149">
          <div className="bg-brand-red text-white text-center py-3 font-bold tracking-wider text-sm uppercase" data-id="element-150">
            🔥 Oferta por Tiempo Limitado — Más del 90% de Ahorro 🔥
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-151">
            <h2 className="text-3xl md:text-4xl font-display font-bold text-gray-900 mb-2" data-id="element-152">
              Obtén la Biblioteca Definitiva Hoy
            </h2>
            <p className="text-gray-500 mb-8" data-id="element-153">
              Acceso instantáneo a los +3,700 libros digitales y futuras
              actualizaciones.
            </p>

            <div className="flex flex-col items-center justify-center mb-8" data-id="element-154">
              <span className="text-gray-400 text-xl font-medium line-through mb-2" data-id="element-155">
                Antes $49.99 USD
              </span>
              <div className="flex items-start justify-center gap-2" data-id="element-156">
                <span className="text-5xl md:text-7xl font-black text-brand-orange tracking-tight" data-id="element-157">
                  <span className="text-3xl md:text-4xl align-top mr-1" data-id="element-158">$</span>
                  3.99
                  <span className="text-2xl md:text-3xl align-top ml-1" data-id="element-159">
                    USD
                  </span>
                </span>
              </div>
              <div className="mt-4 inline-block bg-orange-100 text-brand-orange font-semibold px-4 py-1.5 rounded-full text-sm" data-id="element-160">
                ¡Acceso a +3,700 libros por menos de un café!
              </div>
            </div>

            <div className="space-y-4 max-w-md mx-auto mb-10 text-left" data-id="element-161">
              {['Acceso instantáneo a +3,700 libros premium', 'Organizados en más de 10 colecciones especializadas', 'Formatos PDF de alta calidad', 'Lee en cualquier dispositivo (Celular, Tablet, PC)', 'Acceso de por vida y actualizaciones gratuitas'].map((feature, i) => <div key={i} className="flex items-center gap-3" data-id="element-162">
                  <div className="bg-green-100 p-1 rounded-full shrink-0" data-id="element-163">
                    <CheckIcon size={16} className="text-green-600" data-id="element-164" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-165">{feature}</span>
                </div>)}
            </div>

            <a href="https://pay.hotmart.com/M105206217F?off=j41mgt7g&bid=1780960886484" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto inline-flex justify-center items-center gap-2 px-10 py-5 text-xl font-bold rounded-xl text-white bg-brand-orange hover:bg-orange-600 transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(249,115,22,0.4)] group" data-id="element-166">
              <span data-id="element-167">Obtener Acceso de Por Vida</span>
              <ArrowRightIcon className="group-hover:translate-x-1 transition-transform" data-id="element-168" />
            </a>

            <p className="mt-6 text-sm text-gray-400" data-id="element-169">
              Pago seguro y encriptado. Un solo pago.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}